import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { VscHome } from 'react-icons/vsc';
import { RiHeart3Line, RiHeart3Fill, RiUserLine } from 'react-icons/ri';
import { GoPlusCircle, GoMail } from 'react-icons/go';
import classNames from 'classnames';
import { fetchCurrentUserNotifications } from '../../ducks/user.duck';
import NotificationBadge from '../NotificationBadge/NotificationBadge';
import styles from './BottomNav.module.css';

const FooterNavItems = [
  {
    id: 1,
    icon: <VscHome />,
    activeIcon: <VscHome />,
    route: '/',
    label: 'Home'
  },
  {
    id: 2,
    icon: <RiHeart3Line />,
    activeIcon: <RiHeart3Fill />,
    route: '/favorites',
    label: 'Favorites'
  },
  {
    id: 3,
    icon: <GoPlusCircle />,
    activeIcon: <GoPlusCircle />,
    route: '/l/new',
    label: 'Create Listing'
  },
  {
    id: 4,
    icon: <GoMail />,
    activeIcon: <GoMail />,
    route: '/inbox',
    label: 'Inbox'
  },
  {
    id: 5,
    icon: <RiUserLine />,
    activeIcon: <RiUserLine />,
    route: '/profile-settings',
    label: 'Profile Settings'
  },
];

const BottomNav = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const isAuthenticated = useSelector(state => state.auth?.isAuthenticated);
  const currentUserSaleNotificationCount = useSelector(state => state.user?.currentUserSaleNotificationCount || 0);
  const currentUserOrderNotificationCount = useSelector(state => state.user?.currentUserOrderNotificationCount || 0);
  const notificationCount = isAuthenticated ? currentUserSaleNotificationCount + currentUserOrderNotificationCount : 0;

  useEffect(() => {
    if (isAuthenticated) {
      // Fetch initial counts immediately
      dispatch(fetchCurrentUserNotifications());

      // Setup a background polling interval (e.g. every 60 seconds)
      const interval = setInterval(() => {
        dispatch(fetchCurrentUserNotifications());
      }, 60000);

      return () => clearInterval(interval);
    }
  }, [isAuthenticated, dispatch]);

  const isActive = (route) => {
    if (route === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(route);
  };

  return (
    <div className={styles.bottomNav}>
      {FooterNavItems.map(item => {
        const active = isActive(item.route);
        return (
          <button
            key={item.id}
            className={classNames(styles.navItem, {
              [styles.navItemActive]: active
            })}
            onClick={() => history.push(item.route)}
            aria-label={item.label}
          >
            <div className={styles.iconContainer}>
              {active ? item.activeIcon : item.icon}
              {item.route === '/inbox' && notificationCount > 0 && (
                <NotificationBadge className={styles.notificationBadge} count={notificationCount} />
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default BottomNav;

